import React from "react";
import Joi from "@hapi/joi";
import { withSnackbar } from "notistack";
import Breadcrumb from "../common/breadcum";
import Form from "../common/form";
import { getLine, saveLine } from "../../services/lineService";
import { Grid, Paper, Divider, Container, Button } from "@material-ui/core";
import { messages } from "../common/es_ES";
import TitleComponent from "../common/titleComponent";
import Loading from "../common/loading";
import SaveIcon from "@material-ui/icons/Save";
import { saveProgram } from "../../services/programService";

class ProgramAddForm extends Form {
  state = {
    data: {
      name: "",
      researchline_id: this.props.location.state.state,
    },
    inputValue: "",
    errors: [],
  };

  schema = Joi.object({
    id: Joi.number(),
    name: Joi.string().label("Nombre del Programa").max(200).messages(messages),
    researchline_id: Joi.number(),
  });

  mapToViewModel(line) {
    return {
      id: line.id,
      name: line.name,
      researchline_id: line.researchline_id,
    };
  }

  doSubmit = async () => {
    try {
      const res = await saveProgram(this.state.data);
      this.successMessage();
      this.props.history.push(`/lineas/${this.props.location.state.state}/`);
    } catch (ex) {
      this.errorMessage(ex);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };
        errors.name = ex.response.data.errors.name;
        errors.display_name = ex.response.data.errors.display_name;
        this.setState({ errors });
      }
    }
  };

  async componentDidMount() {
    this.setState({ isLoading: true });
    this.setState({ isLoading: false });
  }

  render() {
    const { data, isLoading, errors } = this.state;
    const listBreadcrumbs = [
      {
        path: `/lineas/${this.props.location.state.state}/`,
        label: "Línea",
      },
    ];
    let validation;
    errors["name"] === undefined ? (validation = false) : (validation = true);
    return (
      <Container maxWidth="sm" id="permissionForm">
        <Loading open={isLoading} />
        <Breadcrumb
          onListBreadcrumbs={listBreadcrumbs}
          lastLabel={"Agregar un programa"}
        />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12}>
            <Paper className="paper">
              <TitleComponent entity={"Programa"} />
              <Divider />
              <form onSubmit={this.handleSubmit}>
                {this.renderInput("name", "Ingrese el nombre del Programa*")}
                <Button
                  onClick={this.doSubmit}
                  color="primary"
                  className="btn btn-guardar"
                  variant="contained"
                  margin="normal"
                  size="medium"
                  startIcon={<SaveIcon />}
                >
                  Guardar Programa
                </Button>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    );
  }
}

export default withSnackbar(ProgramAddForm);
